import { Col, Row, Spin } from 'antd'
import CheckoutDrawer from 'app/components/Core/Checkout/Drawer'
import PackageList from 'app/components/Core/Package/List'
import KFooter from 'app/components/UI-Elements/Layout/KFooter'
import { RecordType } from 'app/constants/GlobalTypes'
import attachmentNormalizer, {
  CategorySegmentAttachmentQuery
} from 'app/lib/apollo/normalizers/Attachment'
import { useQuery } from 'app/lib/hooks/useQuery'
import useTranslation from 'app/lib/hooks/useTranslation'
import { FETCH_CATEGORY_SEGMENT_ATTACHMENTS_QUERY } from 'app/queries/CategorySegment'
import { useState } from 'react'

import SubItemCreate from '../SubItem/Create'

interface Props {
  parentItem: ILineItem
  onSubItemCreate: () => void
}

const subItemPortalId = 'kfooter-subitem-submit'
const subItemCreateDrawerKey = 'sub_item_create'

const footer = (
  <KFooter sticky={false}>
    <div id={subItemPortalId} />
  </KFooter>
)

const Packages: React.FC<Props> = ({ parentItem, onSubItemCreate }) => {
  const { tRecordType } = useTranslation({
    recordType: RecordType.subItem
  })

  const { data, loading } = useQuery<CategorySegmentAttachmentQuery>(
    FETCH_CATEGORY_SEGMENT_ATTACHMENTS_QUERY,
    {
      fetchPolicy: 'cache-and-network',
      normalizer: attachmentNormalizer,
      variables: {
        id: parentItem?.categorySegment?.id,
        lineItemId: parentItem?.id
      }
    }
  )
  const [selectedAttachmentId, setSelectedAttachmentId] = useState<number>(null)

  const onItemClick = (attachment: IAttachment) => {
    setSelectedAttachmentId(attachment.id)
  }

  const onSuccess = () => {
    setSelectedAttachmentId(null)
    onSubItemCreate()
  }

  return (
    <Row>
      <Col span={24}>
        <Spin spinning={loading}>
          <PackageList
            props={{ onItemClick }}
            collection={data?.categorySegment?.activeAttachments}
          />
        </Spin>
      </Col>
      <CheckoutDrawer
        title={tRecordType({ id: 'attachment_details' })}
        onClose={() => setSelectedAttachmentId(null)}
        open={Boolean(selectedAttachmentId)}
        drawerKey={subItemCreateDrawerKey}
        footer={footer}>
        <SubItemCreate
          attachmentId={selectedAttachmentId}
          parentItem={parentItem}
          portalId={subItemPortalId}
          onSuccess={onSuccess}
        />
      </CheckoutDrawer>
    </Row>
  )
}

export default Packages
